import { useAtomValue } from 'jotai';
import { useUserDesc } from '../shared/use-user-desc';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { FC } from 'react';

export const Twitter: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const description = useUserDesc();

  if (!user) {
    return null;
  }

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={user.nickName} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={user.avatar} />
    </>
  );
};
